module.exports = __webpack_public_path__ + "images/img-3IT5sYv.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/en/10.png
// module id = 2334
// module chunks = 0